<div class="checkboxDs__cont checkboxDs__cont--{{align}}" (click)="checkEvent()">
  <div class="checkboxDs__cont__col">
    <div class="checkboxDs__cont__checkbox-input checkboxDs__cont__checkbox-input--{{align}}">
      <input
        type="button"
        class="checkbox-input checkbox-failed-{{failedClass}}"
        [class.checkbox-disabled]="isDisabled"
        [class.checkbox-checked]="checked"
        [disabled]="isDisabled">
        <div class="checkboxDs__cont__checkbox-input__check" *ngIf="checked">
          <app-ds-icon
            [icon]="check"
            [color]="checkColor"
            [size]="20">
          </app-ds-icon>
        </div>
    </div>
    <ng-container *ngIf="alignIsLeft">
      <ng-container *ngTemplateOutlet="checkboxButtonData"></ng-container>
    </ng-container>
  </div>
  <div class="checkboxDs__cont__col">
    <ng-container *ngIf="alignIsRight">
      <ng-container *ngTemplateOutlet="checkboxButtonData"></ng-container>
    </ng-container>
    <ng-container *ngTemplateOutlet="checkboxButtonCounter"></ng-container>
  </div>
</div>

<ng-template #checkboxButtonData>
  <div class="checkboxDs__cont__checkbox-data">
    <ng-container *ngIf="icon">
      <div class="checkboxDs__cont__checkbox-data__icon">
        <app-ds-icon
          [icon]="icon"
          [size]="22"
          [color]="iconFillColor">
        </app-ds-icon>
      </div>
    </ng-container>
    <ng-container *ngIf="image">
      <div class="checkboxDs__cont__checkbox-data__image" [class.disabled]="isDisabled">
        <app-ds-image
          [size]="imageSize"
          [src]="image"
          [objectFit]="'contain'"
          [alt]="image">
        </app-ds-image>
      </div>
    </ng-container>
    <ng-container *ngIf="tagRating">
      <div class="checkboxDs__cont__checkbox-data__tag-rating">
        <app-ds-tag-rating
          [title]="tagRating"
          [type]="tagRatingType.Label"
          [size]="tagRatingSize.SM"/>
      </div>
    </ng-container>
    <ng-container *ngIf="!isTitleEmpty">
      <div class="checkboxDs__cont__checkbox-data__title">
        <app-ds-typography
          [text]="title.Label"
          [color]="fontColor"
          [size]="fontSize"
          [fontFamily]="fontFamily(title)">
        </app-ds-typography>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #checkboxButtonCounter>
  <app-ds-data
    [data]="counter"
    [fontSize]="fontSize"
    [isDisabled]="isDisabled">
  </app-ds-data>
</ng-template>
